import {
  ChatSidebarAccessTags,
  SidebarMenuItemType,
} from '@ltvco/refresh-lib/v2';
import {
  AttachMoneyOutlined,
  AutoAwesomeOutlined,
  CameraAltOutlined,
  CarRepairOutlined,
  LoyaltyOutlined,
} from '@mui/icons-material';

export const ERROR_MESSAGES = {
  TECHNICAL_DIFFICULTIES:
    'We are experiencing technical difficulties getting the vehicle history. Please check your input and try again',
  INVALID_INPUT: 'Invalid input. Please check your input and try again',
  NO_FORECAST_AVAILABLE:
    'We were unable to generate a value forecast for this vehicle. Please try with different vehicle information.',
  NO_VEHICLE_FOUND:
    'No vehicle found using the provided information. Please try with different vehicle information.',
  NO_BUDGET: 'Please enter a valid budget range.',
  INVALID_BUDGET: 'Maximum budget must be greater than minimum budget.',
} as const;

export const chatSidebarAccessTags: ChatSidebarAccessTags = {
  newChat: 'pro',
  additionalToolsSection: 'free',
};

export const additionalSidebarItems: SidebarMenuItemType[] = [
  {
    key: 'photoDamageAnalyzer',
    icon: CameraAltOutlined,
    label: 'Photo Damage Analyzer',
    description: 'Upload photos to get instant damage assessment and costs.',
    url: '/bumper-chat/chat/photo-damage-analyzer',
    tooltip: 'Photo Damage Analyzer',
  },
  {
    key: 'valueForecaster',
    icon: AttachMoneyOutlined,
    label: 'Value Forecaster',
    description:
      "See your car's current market value and predictive forecasts.",
    url: '/bumper-chat/chat/value-forecaster',
    tooltip: 'Value Forecaster',
  },
  {
    key: 'repairCostEstimator',
    icon: CarRepairOutlined,
    label: 'Repair Cost Estimator',
    description: 'Estimate the repair costs for your vehicle.',
    url: '/bumper-chat/chat/repair-cost-estimator',
    tooltip: 'Repair Cost Estimator',
  },
  {
    key: 'vehicleMatchmaker',
    icon: LoyaltyOutlined,
    label: 'Vehicle Matchmaker',
    description:
      "Tell us your budget and lifestyle needs, and we'll recommend the best vehicles.",
    url: '/bumper-chat/vehicle-matchmaker',
    tooltip: 'Smart Vehicle Matchmaker',
  },
  {
    key: 'bumperAIChat',
    icon: AutoAwesomeOutlined,
    label: 'Bumper AI Chat',
    description:
      'Bumper AI Chat is available with Bumper Pro. Upgrade to unlock AI-powered vehicle insights and expert-level answers.',
    landingOnly: true,
    tooltip: 'Bumper AI Chat',
  },
];

export const sidebarNavItems = additionalSidebarItems.filter(
  (item) => !item.landingOnly,
);
